import { render, staticRenderFns } from "./ShipmentDetailsStep.vue?vue&type=template&id=8e76b07e&scoped=true"
import script from "./ShipmentDetailsStep.vue?vue&type=script&lang=js"
export * from "./ShipmentDetailsStep.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetailsStep.vue?vue&type=style&index=0&id=8e76b07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e76b07e",
  null
  
)

export default component.exports